// #base=etc/designs/sitesearch/clientlibs/logic/processing/js

import 'etc/designs/sitesearch/clientlibs/logic/processing/js/SearchProcessor.js';

import 'etc/designs/sitesearch/clientlibs/logic/processing/js/util/backends.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/util/responders.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/util/shims.js';

import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/autosuggest.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/filtering.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/gsa-handling.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/keymatch-handling.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/session-handling.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/spellchecking.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/tracking.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/url-handling.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/web.js';

import 'etc/designs/sitesearch/clientlibs/logic/processing/js/trackers/gsa.js';
import 'etc/designs/sitesearch/clientlibs/logic/processing/js/trackers/sc.js';

import 'etc/designs/sitesearch/clientlibs/logic/processing/js/orchestration.js';

// #base=etc/designs/sitesearch/clientlibs/logic/gui/js/modules
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.HeaderSearchQueryForm.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.OftenSearchedLinkBox.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchClusterSuggestions.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPreviewLink.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPromoBox.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPromoContainer.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultContainer.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultDisplay.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultDisplay.Web.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultFilter.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultQueryBox.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultTitle.js';
import 'etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchTopResults.js';



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.sitesearch.ts